import { toast } from 'sonner';
import {
  DATE_FORMAT_LABELS,
  DATE_FORMAT_STYLES,
  DEFAULT_DATE_FORMAT,
  formatDateWith,
} from '../../lib/dateFormat';
import {
  useCabinetDateFormat,
  useUpdateDateFormat,
} from '../../hooks/queries/useCabinetSettings';
import { cn } from '../../lib/cn';

export function DateFormatSection() {
  const { data: current = DEFAULT_DATE_FORMAT } = useCabinetDateFormat();
  const update = useUpdateDateFormat();
  const sample = new Date();

  return (
    <section className="rounded-cime border border-neutral-200 bg-white p-4 space-y-3">
      <div>
        <h2 className="text-lg font-semibold text-cime-text-primary">Format des dates</h2>
        <p className="text-sm text-cime-text-muted mt-1">
          Le même format partout dans l’application, pour tout le cabinet.
        </p>
      </div>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-3" role="radiogroup" aria-label="Format des dates">
        {DATE_FORMAT_STYLES.map((style) => {
          const on = style === current;
          return (
            <button
              key={style}
              type="button"
              role="radio"
              aria-checked={on}
              disabled={update.isPending}
              onClick={() => {
                if (on) return;
                update.mutate(style, {
                  onSuccess: () => toast.success('Format des dates enregistré'),
                  onError: (err) =>
                    toast.error(
                      err instanceof Error ? err.message : 'Impossible d’enregistrer le format',
                    ),
                });
              }}
              className={cn(
                'rounded-md border p-3 text-left',
                on ? 'border-cime-primary bg-cime-primary/5' : 'border-neutral-200 hover:border-neutral-300',
              )}
            >
              <span className="block text-sm font-medium text-cime-text-primary">
                {DATE_FORMAT_LABELS[style]}
              </span>
              <span className="block text-xs text-cime-text-muted">
                {formatDateWith(style, sample)}
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
